
import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import Dialog from '@material-ui/core/Dialog';
import { blue } from '@material-ui/core/colors';

import CompanyForm from 'Components/CompanyForm';
import CloseIcon from 'img/close-icon.svg';

const useStyles = makeStyles({
  avatar: {
    backgroundColor: blue[100],
    color: blue[600],
  },
  container: {
    padding: "30px",
    paddingTop: 0,
  },
  closeBtn: {
    width: "20px",
    cursor: "pointer",
    position: "absolute",
    top: "15px",
    right: "15px"
  }
});

export default function DefinitionDialog(props) {
  const classes = useStyles();
  const { onClose, open } = props;

  const handleClose = () => onClose()

  return (
    <Dialog onClose={handleClose} aria-labelledby="simple-dialog-title" open={open} disableScrollLock={true}>
      <div onClick={handleClose}><img alt="exit" className={classes.closeBtn} src={CloseIcon} /></div>
      <div className={classes.container}>
        <CompanyForm />
      </div>
    </Dialog>
  );
}

DefinitionDialog.propTypes = {
  onClose: PropTypes.func.isRequired,
  open: PropTypes.bool.isRequired,
  selectedValue: PropTypes.string.isRequired,
};
